/**
 * StationAcknowledgement Component
 *
 * This component displays the acknowledgement text for a specific weather station.
 * It uses the translation context to support multiple languages and displays
 * the acknowledgement with a simple divider line, title, and icon.
 *
 * @param {Object} props - Component props
 * @param {string} props.stationId - The unique identifier for the station
 * @returns {JSX.Element} The rendered StationAcknowledgement component
 */

import React from "react";
import {
  Typography,
  Box,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "../../context/TranslationContext";
import { stationMetaData } from "../../utils/rawData";

const StationAcknowledgement = ({ stationId }) => {
  const { translate } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Find the station data by ID
  const station = stationMetaData.find((station) => station.id === stationId);

  // If station not found, return null
  if (!station) {
    return null;
  }

  return (
    <Box>
      <Divider sx={{ my: 2 }} />

      
      {/* Acknowledgement Text — rendered as HTML so links/icons in the
          acknowledgement string (e.g. the CC BY-NC-SA badge) display correctly */}
      <Typography
        variant={isMobile ? "body2" : "body1"}
        sx={{
          lineHeight: 1.6,
          color: "text.secondary",
          px: isMobile ? 1 : 0,
        }}
        dangerouslySetInnerHTML={{
          __html: translate(station.acknowledgement),
        }}
      />

    </Box>
  );
};

export default StationAcknowledgement;
